@if (loginService.isLoggedIn && !hideCdnBanner) {
<ds-uilab-banner class="cdn-banner" status="warning" #cdnBanner>
    <div bannerContent>
        <div>
            <b> Retirement of cdn.aveva.design </b>
            <p>
                The cdn.aveva.design has been deprecated on 30 June 2026. Use
                the &#64;uilab/icon package instead. If you have any questions,
                <a [routerLink]="['/build', 'contact-us']"
                    >contact the UX team</a
                >.
            </p>
        </div>
        <div>
            <uilab-button
                appearance="text"
                [routerLink]="['/build', 'introduction', 'announcements', 'retirement-of-cdn-aveva-design']"
            >
                Read more
            </uilab-button>
        </div>
    </div>
    <div bannerEnd class="barlow-button">
        <uilab-icon-button
            class="barlow-button__remove"
            (click)="hideCdnBannerEvent()"
        >
            <uilab-icon slot="icon" icon="action--close"></uilab-icon>
        </uilab-icon-button>
    </div>
</ds-uilab-banner>
} @if (loginService.isLoggedIn) {
<app-appbar #appBar></app-appbar>
} @if (loginService.isLoggedIn) {
<section class="uilab-layout-container">
    <app-navrail class="uilab-layout-nav"></app-navrail>
    <section class="uilab-main-canvas">
        <div class="uilab-main-canvas--body">
            <router-outlet></router-outlet>
            @if (homePage) {
            <app-home></app-home>
            } @if (cmsPage || homePage) {
            <div appContent></div>
            } @if (searchPage) {
            <div appSearch></div>
            } @if (postPage) {
            <app-whats-new></app-whats-new>
            }
        </div>
        <app-footer></app-footer>
    </section>
</section>
}
